// extracted by mini-css-extract-plugin
export default {"adminButton":"Header_adminButton__bFhYH","userZone":"Header_userZone__q72wx"};